/**
 * Bottom-of-page Laufið credit carrying the deployed version.
 *
 * `VITE_APP_VERSION` is injected at build time by the Release workflow (the
 * release tag, e.g. `v2.3.0`) and by the staging workflow (`staging-<sha>`).
 * Unset in local dev, where it reads `dev`.
 *
 * The internal release version keeps climbing (3.4, …); the public-facing
 * "Útgáfa" we show is the same number with the major shifted down by two
 * (v3.4.0 → "Útgáfa 1.4.0"). Non-semver values (dev, staging-<sha>) pass
 * through unchanged.
 */
import { useMessages } from '@/i18n/messages'
import { shellMessages } from '@/i18n/text/shell'

const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev'

const PUBLIC_MAJOR_OFFSET = 2

function displayVersion(raw: string, label: (v: string) => string): string {
  const m = /^v?(\d+)\.(\d+)\.(\d+)$/.exec(raw)
  if (!m) return raw
  const major = Math.max(1, Number(m[1]) - PUBLIC_MAJOR_OFFSET)
  return label(`${major}.${m[2]}.${m[3]}`)
}

export function AppFooter() {
  const t = useMessages(shellMessages)
  return (
    <footer className="border-t border-[var(--border)] px-6 py-9 text-center">
      <div className="font-grotesk text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--faint)]">
        Powered by
      </div>
      <img src="/laufid-standard.svg" alt="Laufið" className="mx-auto mt-3 h-7 w-auto" />
      <p className="mt-3.5 text-[13px] font-medium text-[var(--muted)]">
        {t.footerTagline}
      </p>
      <p
        className="mt-2.5 font-grotesk text-[11px] font-semibold tracking-wide text-[var(--faint)]"
        title={t.footerVersionTitle}
      >
        {displayVersion(APP_VERSION, t.version)}
      </p>
    </footer>
  )
}
